import { normalizePermissions } from "@/shared/auth/permissions";
import type { ApiRoleRef, ApiUserProfile } from "@tm-food/api-contract";

export type TokenPair = {
  accessToken: string;
  refreshToken: string;
  accessTokenExpiresAt: string;
};

export type AuthRole = {
  code: string;
  name: string;
};

export type AuthUser = {
  id: string;
  username: string;
  fullName: string;
  plantId: string | null;
  plantCode: string | null;
  plantName: string | null;
  email: string | null;
  phone: string | null;
  roles: AuthRole[];
  permissions: string[];
};

/** Role codes for landing / JWT-style checks. */
export function authRoleCodes(roles: readonly AuthRole[]): string[] {
  return roles.map((r) => r.code);
}

function mapRoleRef(r: ApiRoleRef | string): AuthRole {
  if (typeof r === "string") {
    return { code: r, name: r };
  }
  return {
    code: r.code,
    name: r.name?.trim() || r.code,
  };
}

export function mapUserProfile(dto: ApiUserProfile): AuthUser {
  return {
    id: dto.id,
    username: dto.username,
    fullName: dto.fullName,
    plantId: dto.plantId,
    plantCode: dto.plantCode,
    plantName: dto.plantName ?? null,
    email: dto.email ?? null,
    phone: dto.phone ?? null,
    roles: (dto.roles ?? []).map(mapRoleRef),
    permissions: normalizePermissions(dto.permissions),
  };
}
